import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import Loader from "components/shared/loader";
import { accessPermitRelationTypes } from "helpers/enums";
import { createRequestForUploadFile, getInitialStateFromConfig } from "helpers/form";
import { viewContainer } from "helpers/redux";
import { requiredField } from "helpers/validators";
import React from "react";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    relationType: {
        label: "Тип допуска",
        inputProps: { name: "relationType" },
        validators: [requiredField],
        required: true,
        options: accessPermitRelationTypes,
    },
    image: {
        label: "Изображение",
        inputProps: { name: "image" },
    },
    imageId: {},
    id: {},
};

const initialState = getInitialStateFromConfig(config);

class AccessPermitsShow extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => {
                if (data.image?.id) {
                    data.imageId = data.image.id;
                }
                this.setState({ data, initial: data, ...defParams });
            });
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        if (this.props.match.params.id) {
            return [{ text: "Удалить", action: this.actionClose }];
        } else {
            return [];
        }
    }

    apply = () => {
        const { source, match, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                const paramsRequest = state.data.image
                    ? createRequestForUploadFile("image", state.data.image)
                    : createRequestForUploadFile();
                paramsRequest.body.append("name", state.data.name);
                paramsRequest.body.append("relationType", state.data.relationType);
                if (state.data.imageId) {
                    paramsRequest.body.append("imageId", state.data.imageId);
                }
                if (match.params.id) {
                    paramsRequest.body.append("id", state.data.id);
                }
                return source.apply(paramsRequest).then((res) => {
                    if (res) {
                        match.params.id ? this.update() : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    setValue = ({ value, name }) => {
        const { data, initial } = this.state;
        const nextData = { ...data, [name]: value };
        if (name === "image") {
            nextData.imageId = undefined;
        }
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    renderButton = () => {
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row panel__row--button">
                <div className={cname} onClick={this.apply}>
                    {this.props.match.params.id ? "Обновить" : "Сохранить"}
                </div>
            </div>
        );
    };

    renderBody = () => {
        const { config } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <>
                {this.renderField(config.name)}
                {this.renderSelect(config.relationType)}
                {this.renderFileField(config.image)}
                {this.renderButton()}
            </>
        );
    };

    render() {
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir="full">
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <AccessPermitsShow {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "admin-access-permits");
